module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Avaya Spaces Developer Documentation","short_name":"Avaya Spaces Developer Documentation","start_url":"/","display":"standalone","icon":"src/images/icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"fb83d7b165c7ff69b8303bcacb49dc29"},
    }]
